module.exports = __webpack_public_path__ + "static/media/8_The final lesson_JP.39b0586e.txt";